import React, { useState, useEffect, useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  CardHeader,
  ButtonGroup,
} from "@mui/material";
import { KeyboardTimePicker } from "components/pickers";

// Highcharts component
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";

import swal from "sweetalert";
import * as Service from "../../../services/Service";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { useParams } from "react-router-dom";

import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import { useTranslation } from "react-i18next";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, Edit } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";

import NextPrevBtn from "../../../services/NextPrevBtn";

import { format, subDays } from "date-fns";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const EditProduct = (props) => {
  const StockData = JSON.parse(localStorage.getItem("StockData"));

  const StockDataIndex = JSON.parse(localStorage.getItem("StockDataIndex"));

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const FacilityId = localStorage.getItem("FacilityId");
  const StartDate = localStorage.getItem("StartDate");
  const FacilityName = localStorage.getItem("FacilityName");
  const SourceList = JSON.parse(localStorage.getItem("SourceList"));
  const menukey = "stock-status";
  const [SourceValue, setSourceValue] = useState(0);
  console.log("props: ", props);

  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;

  const classes = useStyles();

  const [value, setValue] = React.useState(0);

  // const [value, setValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const { t, i18n } = useTranslation();

  const { id } = useParams();
  const queryClient = useQueryClient();

  const [MasterData, setMasterData] = useState({});

  const [lotData, setLotData] = useState([]);

  const [lotData2, setLotData2] = useState([]);
  const [option_linechart, setOption_linechart] = useState([]);

  const { data: data } = useQuery(
    ["stock-status-sobaps", id],
    () =>
      api.getLotDataView(id).then((res) => {
        setMasterData(res.MasterData[0]);
        setLotData(res.LotData);
      }),
    {
      enabled: Boolean(id),
    },
  );

  const [stockCardData, setStockCardData] = useState([]);

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(subDays(new Date(), 30), "yyyy-MM-dd"),
  );

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
  };
  const handleStartDateChangeChart = (date) => {
    setSelectedStartDateChart(date);
  };

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    format(new Date(), "yyyy-MM-dd"),
  );

  const [selectedStartDateChart, setSelectedStartDateChart] = React.useState(
    format(subDays(new Date(), 30), "yyyy-MM-dd"),
  );

  const [selectedEndDateChart, setSelectedEndDateChart] = React.useState(
    format(new Date(), "yyyy-MM-dd"),
  );

  let params1 = {
    menukey: menukey,
    FacilityId: FacilityId,
    action: "getStockCardDataView",
    ItemNo: id,
    startDate: selectedStartDate,
    endDate: selectedEndDate,
    SourceId: SourceValue,
  };
  // const { data: scData, refetch } = useQuery([params1],
  //    api.getStockCardDataView,
  //   {onSuccess: (data) => {

  //     setStockCardData(data);

  // }}, {
  //   enabled: Boolean(id),
  // }
  // );

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let formatedStartDate = format(new Date(selectedStartDate), "yyyy-MM-dd");
    let formatedEndDate = format(new Date(selectedEndDate), "yyyy-MM-dd");
    let finalUrl =
      EXCEL_EXPORT_URL +
      "report/stock_status_details_print_pdf_excel_server.php";

    window.open(
      finalUrl +
        "?action=StockCardExcelExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&startDate=" +
        formatedStartDate +
        "&endDate=" +
        formatedEndDate +
        "&FacilityId=" +
        FacilityId +
        "&ItemNo=" +
        id +
        "&FacilityName=" +
        FacilityName +
        "&SourceId=" +
        SourceValue,
    );
  };
  /* =====End of Excel Export Code==== */

  const columns = [
    {
      title: "Id",
      field: "id",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      field: "sl",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["lot No"]),
      field: "LotNo",
      hozAlign: "left",
      headerHozAlign: "left",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Expiry Date"]),
      field: "ExpDate",
      hozAlign: "left",
      headerHozAlign: "left",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Source Name"]),
      field: "SourceName",
      hozAlign: "left",
      headerHozAlign: "left",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Quantity"]),
      field: "LotQty",
      hozAlign: "right",
      headerHozAlign: "right",
      bottomCalc: "sum",
      bottomCalcFormatter: "money",
      bottomCalcFormatterParams: {
        thousand: ",",
        precision: false,
      },
    },
  ];

  const columns1 = [
    { title: "Id", field: "id", width: 50, visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      field: "sl",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["TransactionDate"]),
      width: 130,
      field: "TransactionDate",
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == null ? "" : format(new Date(value), "dd/MM/yyyy");
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Origin/Destination"]),
      field: "Receiver",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Invoice No"]),
      field: "Invoice",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Receive"]),
      field: "ReceivedQty",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 130,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Issue"]),
      field: "IssuedQty",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 130,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Balance"]),
      field: "Balance",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 130,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["lot No"]),
      field: "LotNo",
      hozAlign: "left",
      headerHozAlign: "left",
      width: 100,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Expiry Date"]),
      field: "Exp",
      hozAlign: "left",
      width: 130,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Source Name"]),
      field: "SourceName",
      hozAlign: "left",
      width: 130,
    },
  ];

  /*const dataItems = lotData?.map((item, index) => {
    item["sl"] = index + 1;
    return item;
  });*/

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
  };
  const handleEndDateChangeChart = (date) => {
    setSelectedEndDateChart(date);
  };

  let params2 = {
    menukey: menukey,
    FacilityId: FacilityId,
    action: "getChartDataView",
    ItemNo: id,
    startDate: selectedStartDateChart,
    endDate: selectedEndDateChart,
  };
  // const { data:getChartDataView  } = useQuery([params2],
  //    api.getChartDataView,
  //   {onSuccess: (data) => {

  //  let option_linechart = {
  //       chart: {
  //         //type: "spline",
  //         type: "line",
  //       },
  //       title: {
  //         text: "",
  //       },
  //       yAxis: {
  //         title: {
  //           text: "",
  //         },
  //       },
  //       xAxis: {
  //         categories: data.item_name ,
  //       },
  //       credits: {
  //         enabled: false,
  //       },
  //     //   tooltip: {
  //     //     split: true,
  //     //     distance: 30,
  //     //     padding: 5
  //     // },
  //     tooltip: {
  //       shared: true
  //   },
  //       series: [
  //         {
  //           name: "MIN",
  //           data: data.dataValue[0],//[150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150],
  //           color: "#b60024",
  //         },
  //         {
  //           name: "MAX",
  //           data: data.dataValue[1],//[300, 300, 300, 300, 300, 300, 300, 300, 300, 300, 300, 300],
  //           color: "#6c6463",
  //         },
  //         {
  //           name: "Stock",
  //           data: data.dataValue[2],//[400, 150, 250, 360, 401, 258, 415, 362, 456, 145, 258, 180],
  //           color: "#002f6c",
  //         },
  //       ],
  //     };

  //    setOption_linechart(option_linechart);

  // }}, {
  //   enabled: Boolean(id),
  // }
  // );

  const [formData, setFormData] = useState({
    productName: "",
    productCode: "",
    productGroup: "",
    price: "",
    key: false,
    productId: "",
  });
  const [groupData, setGroupData] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      productName: "",
      productCode: "",
      productGroup: "",
      price: "",
      key: false,
    });
  };

  const handleSubmit = async (e) => {
    swal("Success!", "", "success");
  };

  useEffect(() => {
    setLotData2(lotData);
  }, [lotData]);

  const [all, setAll] = React.useState("0");

  const handleChangeSource = (event) => {
    setAll(event.target.value);
    //setLoading(true);
    //console.log(e.target.value);
    setSourceValue(event.target.value);
  };

  const handleIndex = (indx, row) => {
    localStorage.setItem("StockDataIndex", JSON.stringify(indx));
    let route = `${row.ItemNo}`;
    props.history.push(route);
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-1">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {DispensingLanguage[lan][menukey]["Stock Status"]}
                </div>

                <div className="float-end sw_btn_control">
                  <Button
                    variant="contained"
                    color="gray"
                    type="reset"
                    onClick={() => props.history.push("/stock-status-sobaps")}
                  >
                    {DispensingLanguage[lan][menukey]["RETURN TO LIST"]}
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <NextPrevBtn
          dataList={StockData}
          StockDataIndex={StockDataIndex}
          handleReset={""}
          handleIndex={handleIndex}
          {...props}
        />

        {/* start of form*/}
        <Card className="sw_card mb-2">
          <CardContent>
            <Grid container>
              <Grid item xs={12} sm={12}>
                <ul className="sw_item_list">
                  <li>
                    <strong>
                      {" "}
                      {DispensingLanguage[lan][menukey]["Product Code"]}:
                    </strong>{" "}
                    {MasterData.ProductCode}
                  </li>
                  <li>
                    <strong>
                      {DispensingLanguage[lan][menukey]["Product Name"]}:
                    </strong>{" "}
                    {MasterData.ProductName}
                  </li>
                  <li>
                    <strong>{DispensingLanguage[lan][menukey]["AMC"]}:</strong>{" "}
                    {MasterData.AMC}
                  </li>
                  <li>
                    <strong>
                      {DispensingLanguage[lan][menukey]["Minimum Quantity"]}:
                    </strong>{" "}
                    {MasterData.MinimumQuantity}
                  </li>
                  <li>
                    <strong>
                      {DispensingLanguage[lan][menukey]["Maximum Quantity"]}:
                    </strong>{" "}
                    {MasterData.MaximumQuantity}
                  </li>
                  <li>
                    <strong>
                      {DispensingLanguage[lan][menukey]["Quantity"]}:
                    </strong>{" "}
                    {MasterData.Quantity}
                  </li>
                  <li>
                    <strong>
                      {DispensingLanguage[lan][menukey]["Unit Price"]}:
                    </strong>{" "}
                    {MasterData.UnitPrice}
                  </li>
                  <li>
                    <strong>
                      {DispensingLanguage[lan][menukey]["Line Total"]}:
                    </strong>{" "}
                    {MasterData.LineTotal}
                  </li>
                </ul>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of form*/}

        {/* data grid*/}
        <Grid container spacing={3}>
          {/* new row */}
          <Grid item xs={12} sm={12}>
            <div className={classes.root}>
              <Card className="sw_card">
                <CardContent>
                  <Box sx={{ width: "100%" }}>
                    <AppBar position="static" color="default" className="mb-2">
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                          value={value}
                          onChange={handleTabChange}
                          aria-label="basic tabs example"
                        >
                          <Tab
                            label={DispensingLanguage[lan][menukey]["Lots"]}
                            {...a11yProps(0)}
                          />
                          {/* <Tab
                            label={
                              DispensingLanguage[lan][menukey]["Stock Card"]
                            }
                            {...a11yProps(1)}
                          />
                          <Tab
                            label={
                              DispensingLanguage[lan][menukey]["Stock Chart"]
                            }
                            {...a11yProps(2)}
                          />*/}
                        </Tabs>
                      </Box>
                    </AppBar>

                    <TabPanel value={value} index={0}>
                      <TableContainer component={Paper}>
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableBody>
                            <ReactTabulator
                              onRef={(r) => {
                                tblRef.table = r.current;
                              }}
                              columns={columns}
                              data={lotData2}
                              layout={"fitColumns"}
                            />
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <Grid container spacing={3} className="mb-2">
                        <Grid item xs={2} sm={2}>
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={lan === "en_GB" ? enGB : fr}
                          >
                            <Grid container justifyContent="space-around">
                              <DatePicker
                                //disableToolbar
                                inputFormat="dd/MM/yyyy"
                                label={
                                  DispensingLanguage[lan][menukey]["Start Date"]
                                }
                                value={selectedStartDate}
                                onChange={handleStartDateChange}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    className={classes.fullWidth}
                                  />
                                )}
                              />
                            </Grid>
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={2} sm={2}>
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={lan === "en_GB" ? enGB : fr}
                          >
                            <Grid container justifyContent="space-around">
                              <DatePicker
                                //disableToolbar
                                inputFormat="dd/MM/yyyy"
                                label={
                                  DispensingLanguage[lan][menukey]["End Date"]
                                }
                                value={selectedEndDate}
                                onChange={handleEndDateChange}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    className={classes.fullWidth}
                                  />
                                )}
                              />
                            </Grid>
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={2} sm={2}>
                          <FormControl
                            variant="standard"
                            className={classes.fullWidth}
                          >
                            <InputLabel id="demo-simple-select-helper-label">
                              {DispensingLanguage[lan][menukey]["Source"]}
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-helper-label"
                              id="SourceId"
                              name="SourceId"
                              value={all}
                              onChange={handleChangeSource}
                              fullWidth
                              label={DispensingLanguage[lan][menukey]["Source"]}
                            >
                              <MenuItem value="0">
                                {" "}
                                {DispensingLanguage[lan][menukey]["All"]}
                              </MenuItem>

                              {SourceList.map((item, index) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={6} sm={6}>
                          <div className="float-end sw_btn_control">
                            <Button
                              variant="contained"
                              color="primary"
                              className="me-2 sw_icons"
                              onClick={() =>
                                PrintPDFExcelExportFunction("print")
                              }
                            >
                              <i className="fas fa-print"></i>
                            </Button>

                            <Button
                              variant="contained"
                              color="primary"
                              className="me-2 sw_icons"
                              onClick={() =>
                                PrintPDFExcelExportFunction("excel")
                              }
                            >
                              <i className="far fa-file-excel"></i>
                            </Button>
                          </div>
                        </Grid>
                      </Grid>

                      <TableContainer component={Paper}>
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableBody>
                            <ReactTabulator
                              columns={columns1}
                              layout={"fitColumns"}
                              data={stockCardData}
                              layout={"fitColumns"}
                              height="450px"
                              options={{
                                groupBy: "ProductFullName",
                                columnCalcs: "both",
                              }}
                            />
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                      <Grid container spacing={3} className="mb-2">
                        <Grid item xs={2} sm={2}>
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={lan === "en_GB" ? enGB : fr}
                          >
                            <Grid container justifyContent="space-around">
                              <DatePicker
                                // disableToolbar
                                inputFormat="dd/MM/yyyy"
                                label={
                                  DispensingLanguage[lan][menukey]["Start Date"]
                                }
                                value={selectedStartDateChart}
                                onChange={handleStartDateChangeChart}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    className={classes.fullWidth}
                                  />
                                )}
                              />
                            </Grid>
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={2} sm={2}>
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={lan === "en_GB" ? enGB : fr}
                          >
                            <Grid container justifyContent="space-around">
                              <DatePicker
                                // disableToolbar
                                inputFormat="dd/MM/yyyy"
                                label={
                                  DispensingLanguage[lan][menukey]["End Date"]
                                }
                                value={selectedEndDateChart}
                                onChange={handleEndDateChangeChart}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    className={classes.fullWidth}
                                  />
                                )}
                              />
                            </Grid>
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={8} sm={8}></Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} sm={12}>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={option_linechart}
                          />
                        </Grid>
                      </Grid>
                    </TabPanel>
                  </Box>
                </CardContent>
              </Card>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default EditProduct;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
  th: {
    "border-left": "1px solid red",
  },
});
